'use client'
import { useEffect, useState } from 'react'

import Image from 'next/image'

import ICONS from '@/assets/icons'
import { useDebounce } from '@/hooks'

import styles from './styles.module.css'

type SearchProps = {
  handleSearch: (e?: string) => void
  debounceSecond?: number
  defaultValue?: string
}
export const SearchComponent = ({ handleSearch, debounceSecond, defaultValue }: SearchProps) => {
  const [search, setSearch] = useState<string>('')
  const debounce = useDebounce(search, debounceSecond || 500)

  useEffect(() => {
    setSearch(defaultValue || '')
  }, [defaultValue])

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    handleSearch(debounce)
  }

  useEffect(() => {
    if (!debounce) {
      handleSearch('')
    }
  }, [debounce])

  return (
    <form onSubmit={onSubmit} className={styles.containerSearchBar}>
      <Image src={ICONS.icSearchGray} alt="search" className="" width={24} height={24} />
      <input
        value={search}
        className="text-[14px] font-semibold w-full"
        name="search"
        type="text"
        onChange={(e) => {
          setSearch(e.target.value)
        }}
        placeholder="Search..."
      />
    </form>
  )
}
